export default "__VITE_ASSET__DvrrVCyN__"